import React, {Component} from 'react';
import {Row, Col, Form, ControlLabel, FormControl, FormGroup} from "react-bootstrap";
import ReactNotify from 'react-notify';
import RodzajeKalendarzyTable from "./components/RodzajeKalendarzyTable";
import {TopButtonAdd, TopButtonCancel, TopButtonSave} from "../../../../../componentsTopsa/buttons/TopButtons";
import RodzajKalendarzyService from "./RodzajKalendarzyService";
import ButtonToolbar from "react-bootstrap/es/ButtonToolbar";
import Validator from "../../../../../utilities/Validator";
import ValidatorMessages from "../../../../../shared/validatorMessages/ValidatorMessages";
import ScrollUtilities from "../../../../../utilities/ScrollUtilities";


export default class RodzajeKalendarzyContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            kalendarze:[],
            edycja:null,
            nazwa:'',
            validatorMessages: [],
        };
        this.onChangeNazwa = this.onChangeNazwa.bind(this)
        this.pobierzKalendarze = this.pobierzKalendarze.bind(this)
        this.onClickSave = this.onClickSave.bind(this)
        this.onClickEdytuj = this.onClickEdytuj.bind(this)
        this.onClickUsun = this.onClickUsun.bind(this)
        this.onCancelSave = this.onCancelSave.bind(this)
    }

    componentDidMount(){
        this.pobierzKalendarze()
    }

    pobierzKalendarze(){
        RodzajKalendarzyService.getKalendarze().then(function (response) {
            this.setState({kalendarze:response.data.content})
        }.bind(this))
    }

    onChangeNazwa(e){
        if(Validator.validateLenghtWithClearing(e.target.value,30,'inputNazwa',this.state.nazwa)){
            this.setState({nazwa:e.target.value})
        }
    }

    dodajDoValidatorMessages(msg) {
        let arr = this.state.validatorMessages;
        arr.push(msg)
        this.setState({validatorMessages: arr})
    }

    onClickSave(){

        let poprawne = true; this.state.validatorMessages = [];

        if(!Boolean(this.state.nazwa)){
            poprawne = false;
            this.dodajDoValidatorMessages('Nie uzupełniono nazwy kalendarza')
        }

        if(poprawne){

            this.state.validatorMessages = [];

            if(Boolean(this.state.edycja)){
                // edycja
                RodzajKalendarzyService.editKalendarz(this.state.edycja.idRk,{"nazRk":this.state.nazwa}).then(function (response) {
                    if (response.status < 300) {
                        this.refs.notificator.success('Pomyślnie edytowano rodzaj kalendarza', "", 3000)
                        this.pobierzKalendarze();
                    }
                    else {
                        this.refs.notificator.error('Wystąpił błąd podczas edycji rodzaju kalendarza', "", 3000)
                    }
                }.bind(this))
            }
            else{
                // dodawanie
                RodzajKalendarzyService.addKalendarz({"nazRk":this.state.nazwa}).then(function (response) {
                    if (response.status < 300) {
                        this.refs.notificator.success('Pomyślnie dodano rodzaj kalendarza', "", 3000)
                        this.pobierzKalendarze();
                    }
                    else {
                        this.refs.notificator.error('Wystąpił błąd podczas dodawania rodzaju kalendarza', "", 3000)
                    }
                }.bind(this))
            }

            this.setState({nazwa:'',edycja:null});
            document.getElementById('inputNazwa').value ='';

        }
    }

    onClickEdytuj(obj) {
        this.setState({edycja: obj,nazwa:obj.nazRk})
        document.getElementById('inputNazwa').value =obj.nazRk;
        ScrollUtilities.scrollToTop()
    }

    onClickUsun(obj) {
        if (window.confirm('Czy usunąc kalendarz: ' + obj.nazRk)) {
            RodzajKalendarzyService.deleteKalendarz(obj.idRk).then(function (response) {
                if (response.status < 300) {
                    this.refs.notificator.success('Pomyślnie usunięto kalendarz', "", 3000)
                    this.pobierzKalendarze();
                }
                else {
                    this.refs.notificator.error('Wystąpił błąd podczas usuwania kalendarza', "", 3000)
                }
            }.bind(this))
        }
    }

    onCancelSave(){
        this.setState({nazwa:'',edycja:null});
        document.getElementById('inputNazwa').value ='';
    }

    render() {

        return (
            <div>
                <ReactNotify ref='notificator'/>
                <Row>
                    <Col xs={12} md={8} lg={6}>

                            <Form horizontal={true}>
                                <FormGroup>
                                <Col xs={6} sm={6}>
                                    <ControlLabel>Nazwa kalendarza</ControlLabel>
                                    <FormControl onChange={this.onChangeNazwa} id={'inputNazwa'}/>
                                </Col>
                                <Col xs={6} sm={6}>
                                    <div className={'add-label-margin'}></div>
                                    {
                                        Boolean(this.state.edycja)?
                                            <ButtonToolbar>
                                                <TopButtonCancel onClick={this.onCancelSave} text={'Anuluj'}/>
                                            <TopButtonSave onClick={this.onClickSave} text={'Zapisz'}/>
                                            </ButtonToolbar>
                                            :
                                            <TopButtonAdd onClick={this.onClickSave} text={'Dodaj nowy'}/>
                                    }
                                </Col>
                                </FormGroup>
                                <FormGroup>
                                    <ValidatorMessages messages={this.state.validatorMessages}/>
                                </FormGroup>
                            </Form>

                    </Col>
                    <Col xs={12}>
                        <RodzajeKalendarzyTable data={this.state.kalendarze}
                                                wlaczSzukanie={true}
                                                handleEdytuj={this.onClickEdytuj}
                                                handleUsun={this.onClickUsun}/>
                    </Col>
                </Row>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/konfiguracja/rozkladConfig/kalendarze/rodzajeKalendarzy/RodzajeKalendarzyContainer.js